module.exports = "<app-coupon (close)=\"onClose()\"></app-coupon><button class=\"cross--normal\" type=\"button\" (click)=\"onClose()\"></button>";